import React from 'react';
import moment from 'moment';
import { getProxyUrl } from '../../utils/image';
import { getArenaBg } from '../../utils/matches';
import { LEAGUES } from "../../constants/leagues";

function MatchHeaderOngoingFinished({ match, homeTeamLogo, visitingTeamLogo }) {
  const {
    homeTeamName,
    visitingTeamName,
    homeTeamAbbrv,
    homeTeamScore,
    visitingTeamScore,
    startDate,
  } = match;
  const arenabg = match?.configLeagueName !== LEAGUES.FUTSAL ?
      getProxyUrl(getArenaBg(homeTeamAbbrv), 1400, 788) :
      '/wp-content/themes/sef-leagues/images/match-hero.png';

  const niceDate = moment(startDate).format('ddd D MMM HH:mm');

  const getGoals = (homeTeam) => {
    if (homeTeam) {
      const g = match?.matchEvents
        ?.filter((x) => x.type === 'GOAL')
        .filter((x) => x.byHomeTeam);
      return g.map((e) => ({
        player: e.playerName,
        minute: e.minuteWithStoppageTime,
        goalType: e.goalType
      }));
    }

    const g = match?.matchEvents
      ?.filter((x) => x.type === 'GOAL')
      .filter((x) => !x.byHomeTeam);
    return g.map((e) => ({
      player: e.playerName,
      minute: e.minuteWithStoppageTime,
      goalType: e.goalType
    }));
  };

  const eventClasses = (isHomeTeam) => {
    return {
      item: isHomeTeam ?
          'justify-content-end justify-content-lg-start' :
          'justify-content-start justify-content-lg-end',
      goals: isHomeTeam ?
          'order-2 order-lg-0' :
          'order-0 order-lg-2',
      scorer: isHomeTeam ?
          'order-0 order-lg-2 text-end' :
          'order-2 order-lg-0 text-start'
    }
  }

  const renderGoals = (homeTeam) => {
    const goals = getGoals(homeTeam);
    const classes = eventClasses(homeTeam);

    return goals.map((g) => (
      <li className={`match-events__item ${classes.item}`}>
        <span className={`match-events__minute text-center ${classes.goals}`}>
          {g?.minute}
        </span>
        <object className="order-1" width="17" height="17" data="/wp-content/themes/sef-leagues/images/football-logo.svg" type="image/svg+xml"></object>
        <span className={classes.scorer}>{(g.goalType === "own goal") ? 'Självmål' : g.player}</span>
      </li>
    ));
  };

  const getMatchTime = () => {
    if (match?.matchMinuteWithStoppage === 'FT') {
      return 'SLUT';
    }

    return match?.matchMinuteWithStoppage;
  };

  return (
    <div
      className="hero-image__container hero-image__container--match d-flex align-content-start align-items-lg-center"
      style={{
        backgroundImage: `url('${arenabg}')`,
      }}
    >
      <div className="match-hero">
        <div className="match-hero__team match-hero__team--live">
          <img
            className="match-hero__team-logo"
            src={homeTeamLogo}
            alt="arena"
          />
          <div className="match-hero__team-item align-items-center align-items-lg-start">
            <p className="match-hero__team-name heading-h6 heading-lg-h4 text-transform-none mb-2 text-center text-lg-left">
              {homeTeamName}
            </p>
            <ul className="match-events">{renderGoals(true)}</ul>
          </div>
        </div>
        <div className="match-hero__score match-hero__score--live">
          <p className="heading-h3 heading-md-h2">
            {homeTeamScore} - {visitingTeamScore}
          </p>
          <p className="heading-h6 mb-2">{getMatchTime()}</p>
        </div>
        <div className="match-hero__team match-hero__team--live">
          <div className="match-hero__team-item align-items-center align-items-lg-end order-1 order-lg-0">
            <p className="match-hero__team-name heading-h6 heading-lg-h4 text-transform-none mb-2 text-center text-lg-left">
              {visitingTeamName}
            </p>
            <ul className="match-events">{renderGoals(false)}</ul>
          </div>
          <img
            className="match-hero__team-logo order-0 order-lg-1"
            src={visitingTeamLogo}
            alt=""
          />
        </div>
        <div className="match-hero__info d-flex align-items-lg-center gap-3 gap-lg-5 justify-content-center mt-auto">
          <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
            <img
              width="20"
              src="/wp-content/themes/sef-leagues/images/calendar-logo.png"
              alt="Date"
            />
            <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
              {niceDate}
            </p>
          </div>
          <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
            <img
              width="20"
              src="/wp-content/themes/sef-leagues/images/referee-logo.png"
              alt="Referee"
            />
            <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
              {match?.referees?.length > 0 && match?.referees[0]}
            </p>
          </div>
          <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
            <img
              width="20"
              src="/wp-content/themes/sef-leagues/images/arena-logo.png"
              alt="Arena"
            />
            <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
              {match?.arenaName}
            </p>
          </div>
          <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
            <img
              width="20"
              src={`/wp-content/themes/sef-leagues/images/${match?.configLeagueName}-icon.png`}
              alt="League"
            />
            <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
              OMGÅNG {match?.round}
            </p>
          </div>
          {match?.spectators && (
              <div className="d-flex flex-column flex-lg-row justify-content-start justify-content-lg-center align-items-center gap-2">
                <img
                    width="20"
                    src="/wp-content/themes/sef-leagues/images/arena-capacity.png"
                    alt="Attendance"
                />
                <p className="text-lg-small text-tiny text-uppercase text-center text-lg-start">
                  {match?.spectators}
                </p>
              </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MatchHeaderOngoingFinished;
